<script setup lang="ts">
import { ref } from 'vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { ElConfigProvider } from 'element-plus'

const elementConfig = ref({
  zIndex: 2000, // 默认值
})
</script>

<template>
  <el-config-provider :locale="zhCn" :z-index="elementConfig.zIndex">
    <RouterView />
  </el-config-provider>
</template>

<style lang="scss">
.size {
  width: 100%;
  height: 100%;
}

html,
body {
  @extend .size;

  padding: 0 !important;
  margin: 0;
  overflow-y: auto; // 改为 auto，让 body 可以滚动  也直接去掉 overflow: hidden


  #app {
    @extend .size;
  }
}
</style>
